export default __webpack_public_path__ + "static/media/jadwal-raffle.dc55415e.png";